import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@bem-react/classname'

import './Guide.scss'

const cnGuide = cn('Guide')

interface GuideProps {
  className?: string
}

export const Guide: FC<GuideProps> = ({
  className,
}: GuideProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className={cnGuide(null, [className])}>
      <div className={cnGuide('title')}>
        {t('landing-guide-title-first')}{' '}
        <span>{t('landing-guide-title-second')}</span>
      </div>
      <div className={cnGuide('steps')}>
        <div className={cnGuide('step')}>
          <div className={cnGuide('subtitle')}>
            {t('landing-guide-step-1-title')}
            <div className={cnGuide('arrow')}></div>
          </div>
          <div className={cnGuide('text')}>
            {t('landing-guide-step-1-text')}
          </div>
        </div>
        <div className={cnGuide('step')}>
          <div className={cnGuide('subtitle')}>
            {t('landing-guide-step-2-title')}
            <div className={cnGuide('arrow')}></div>
          </div>
          <div className={cnGuide('text')}>
            {t('landing-guide-step-2-text')}
          </div>
        </div>
        <div className={cnGuide('step')}>
          <div className={cnGuide('subtitle')}>
            {t('landing-guide-step-3-title')}
          </div>
          <div className={cnGuide('text')}>
            {t('landing-guide-step-3-text')}
          </div>
        </div>
      </div>
    </div>
  )
}
